import { Price } from "@repo/components/atoms/price";
import type { FragmentOfShopifyStorefront } from "@repo/graphql-shopify-storefront";
import {
  graphqlShopifyStorefront,
  readFragmentShopifyStorefront,
} from "@repo/graphql-shopify-storefront";
import { cn } from "@repo/lib";

export const PriceAndCompareAtPrice_Product_Fragment =
  graphqlShopifyStorefront(`
  fragment PriceAndCompareAtPrice_Product on Product {
    compareAtPriceRange {
      maxVariantPrice {
        amount
        currencyCode
      }
      minVariantPrice {
        amount
        currencyCode
      }
    }
    priceRange {
      maxVariantPrice {
        amount
        currencyCode
      }
      minVariantPrice {
        amount
        currencyCode
      }
    }
  }
`);

export function PriceAndCompareAtPrice({
  className,
  currencyCodeClassName,
  productMasked,
  lang,
}: {
  className?: string;
  currencyCodeClassName?: string;
  productMasked: FragmentOfShopifyStorefront<
    typeof PriceAndCompareAtPrice_Product_Fragment
  >;
  lang: Navigator["language"];
} & React.ComponentProps<"div">) {
  const product = readFragmentShopifyStorefront(
    PriceAndCompareAtPrice_Product_Fragment,
    productMasked,
  );

  if (!product) {
    console.error("No product data found");
    return null;
  }

  return (
    <div className={cn("grid justify-start gap-x-4 gap-y-2", className)}>
      <Price
        amount={product.priceRange.minVariantPrice.amount}
        className={cn({
          "text-destructive":
            product.compareAtPriceRange?.minVariantPrice.amount >
            product.priceRange?.minVariantPrice.amount,
        })}
        currencyCode={product.priceRange.minVariantPrice.currencyCode}
        currencyCodeClassName={currencyCodeClassName}
        lang={lang}
      />

      {product.compareAtPriceRange?.minVariantPrice.amount >
        product.priceRange?.minVariantPrice.amount && (
        <Price
          amount={product.compareAtPriceRange.minVariantPrice.amount}
          className="line-through decoration-destructive"
          currencyCode={
            product.compareAtPriceRange.minVariantPrice.currencyCode
          }
          currencyCodeClassName={currencyCodeClassName}
          lang={lang}
        />
      )}
    </div>
  );
}
